export enum VehicleDocumentType {
  LEASING_CONTRACT = 'LEASING_CONTRACT',
  WARRANTY = 'WARRANTY',
  SALES_CONTRACT = 'SALES_CONTRACT',
  SALES_OFFER = 'SALES_OFFER',
  SERVICE = 'SERVICE'
}
